import { combineReducers } from 'redux'

export const Types = {
  LOAD_HONEYMOON: 'load_honeymoon',
  LOAD_HONEYMOON_SUCCESS: 'load_honeymoon_success',
  LOAD_HONEYMOON_ERROR: 'load_honeymoon_error',
  CHANGE_PRICE_ORDER: 'change_price_order',
}

export function loadHoneymoon() {
  return {
    type: Types.LOAD_HONEYMOON,
  }
}

export function loadHoneymoonSuccess(payload) {
  return {
    type: Types.LOAD_HONEYMOON_SUCCESS,
    payload,
  }
}

export function loadHoneymoonError(payload) {
  return {
    type: Types.LOAD_HONEYMOON_ERROR,
    payload,
  }
}

export function changePriceOrder(payload) {
  return {
    type: Types.CHANGE_PRICE_ORDER,
    payload,
  }
}

function sortHoneymoon(list, filter) {
  switch (filter) {
    case 'asc':
      return [...list.sort((a, b) => {
        const aPrice = parseFloat(a.present.price)
        const bPrice = parseFloat(b.present.price)

        if (aPrice > bPrice) return 1
        if (aPrice < bPrice) return -1
        return 0
      })]
    case 'desc':
      return [...list.sort((a, b) => {
        const aPrice = parseFloat(a.present.price)
        const bPrice = parseFloat(b.present.price)

        if (aPrice < bPrice) return 1
        if (aPrice > bPrice) return -1
        return 0
      })]
    default: return [...list]
  }
}

function honeymoonReducer(state = [], action) {
  switch (action.type) {
    case Types.LOAD_HONEYMOON_SUCCESS:
      return [...action.payload]
    case Types.CHANGE_PRICE_ORDER:
      return sortHoneymoon(state, action.payload)
    default: return state
  }
}

function orderReducer(state = 'asc', action) {
  switch (action.type) {
    case Types.CHANGE_PRICE_ORDER:
      return action.payload
    default: return state
  }
}

export default combineReducers({
  list: honeymoonReducer,
  priceSort: orderReducer,
})
